<template>
  <div
    class="lds-ring"
    :style="{
      width: `${width}px`,
      height: `${width}px`
    }"
  ></div>
</template>

<script lang="ts">
import { defineComponent } from "vue";

export default defineComponent({
  name: "component-spinner",
  props: {
    width: {
      type: Number,
      default: 70,
      required: false
    },
    height: {
      type: Number,
      default: 70,
      required: false
    }
  }
});
</script>

<style scoped lang="scss">
.lds-ring {
  border: 3px solid $gloom;
  border-radius: 50%;
  border-right-color: transparent;
  box-sizing: border-box;
  animation: lds-ring 1.2s infinite linear;
}
@keyframes lds-ring {
  0% {
    transform: none;
  }
  100% {
    transform: rotate(360deg);
  }
}
</style>
